import React, { useMemo, useState, useCallback } from 'react'
import BigNumber from 'bignumber.js'
import styled from 'styled-components'
import useI18n from 'hooks/useI18n'
import { Button, Flex, Text, useModal } from '@pancakeswap-libs/uikit'
import { useERC20 } from 'hooks/useContract'
import { useAllowance } from 'hooks/useAllowance'
import { useTokenApprove } from 'hooks/useApprove'
import { getEbenAddress } from 'utils/addressHelpers'
import { useMintInscriptionsToken, useBurn, useEbenBalance } from '../hooks/useSep20Factory'
import BurnMoal from './BurnMoal'


const Action = styled.div`
    padding-top: 5px;
`

interface CardActionsProps {
    token: any,
    account?: string
}

const CardActions: React.FC<CardActionsProps> = ({ token, account }) => {
    const TranslateString = useI18n();
    const { address, decimals, isMintable, mintFee } = token;

    // Mint
    const [flag, setRequested] = useState(1);
    const tokenContract = useERC20(getEbenAddress());
    const allowance = useAllowance(tokenContract, address, flag);
    const onApprove = useTokenApprove(tokenContract, address)
    const allowed = mintFee.isEqualTo(0) || (allowance && !allowance.div(new BigNumber(10).pow(18)).isLessThan(mintFee));
    const [requestedApproval, setRequestedApproval] = useState(false)
    const handleApprove = useCallback(async () => {
        try {
            setRequestedApproval(true)
            const txHash = await onApprove()
            setRequestedApproval(false)
            if (txHash) {
                setRequested(Math.random());
                return true;
            }
        } catch (e) {
            console.error(e)
        }
        return false;
    }, [onApprove])

    const mint = useMintInscriptionsToken(address);
    const [pendingTx, setPendingTx] = useState(false)
    const ebenBalance = useEbenBalance(flag);
    const hasEnoughFee = mintFee.isEqualTo(0) || ebenBalance.isGreaterThanOrEqualTo(mintFee);
    const handleSubmit = useCallback(async () => {
        try {
          const txHash = await mint();
          // user rejected tx or didn't go thru
          if (txHash) {
            setRequested(Math.random())
          }
        } catch (e) {
          console.error(e)
        }
      }, [mint, setRequested])

    // Burn
    const tokenBalance = token.userBalance? token.userBalance.toFixed() : '0';
    const onBurnSubmit = useBurn(token)
    const onBurnModalConfirm = async (amount) => {
        return onBurnSubmit(new BigNumber(amount));
    };
    const [onBurnStart] = useModal(<BurnMoal max={tokenBalance} token={token} onConfirm={onBurnModalConfirm} />)

    return (
        <Action>
            <Button fullWidth onClick={onBurnStart}>
                {TranslateString(546,'Burn')}
            </Button>
            <Button
                fullWidth mt="8px"
                disabled={pendingTx || !isMintable || !hasEnoughFee}
                onClick={async () => {
                    setPendingTx(true);
                    let skip:any = false;
                    if (!allowed) {
                        skip = !(await handleApprove());
                    } 
                    if (!skip) await handleSubmit();
                    setPendingTx(false)
                }}
            >
                {requestedApproval ? `${TranslateString(330, "Approving")}...` : TranslateString(547,'Mint')}
            </Button>
        </Action>
    );
}

export default CardActions
